import { LiveKitRoom } from "@livekit/components-react";
import useStudioConnection from "./useStudioConnection";
import StudioPage from "./StudioPage";

export function Studio() {
  const { token, serverUrl, connectionsParams } = useStudioConnection();

  return (
    <div>
      {token && serverUrl && (
        <LiveKitRoom
            token={token}
            serverUrl={serverUrl}
            audio={false}
            video={false}
        >
          <StudioPage connectionsParams={connectionsParams} />
        </LiveKitRoom>
      )}
    </div>
  );
}
